import { get } from "../index";

export const getProjectContributions = (projectId, days = 90) =>
  get(`/analytics/project/${projectId}/contributions?days=${days}`);

export const getProjectOverview = (projectId) =>
  get(`/analytics/project/${projectId}/overview`);

export const getProjectRecommendations = (projectId) =>
  get(`/analytics/project/${projectId}/recommendations`);

// Company-wide (all accessible projects) analytics
const buildFilterQuery = (filters = {}) => {
  const p = new URLSearchParams();
  if (filters.days != null) p.append("days", filters.days);
  if (filters.projectIds?.length) p.append("projectIds", filters.projectIds.join(","));
  if (filters.disciplineIds?.length) p.append("disciplineIds", filters.disciplineIds.join(","));
  if (filters.milestoneIds?.length) p.append("milestoneIds", filters.milestoneIds.join(","));
  if (filters.userIds?.length) p.append("userIds", filters.userIds.join(","));
  if (filters.revisionIds?.length) p.append("revisionIds", filters.revisionIds.join(","));
  const q = p.toString();
  return q ? `?${q}` : "";
};

export const getCompanyOverview = (filters = {}) =>
  get(`/analytics/overview${buildFilterQuery(filters)}`);

export const getCompanyContributions = (days = 90, filters = {}) =>
  get(`/analytics/contributions${buildFilterQuery({ ...filters, days })}`);

export const getCompanyRecommendations = (filters = {}) =>
  get(`/analytics/recommendations${buildFilterQuery(filters)}`);

// Per-user analytics (admin / companyAdmin / self only)
export const getUserOverview = (userId) =>
  get(`/analytics/user/${userId}/overview`);

export const getUserContributions = (userId, days = 90) =>
  get(`/analytics/user/${userId}/contributions?days=${days}`);
